import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({

    root: {
        backgroundColor: '#F7FAFF',
      },
    
      mainContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        padding: theme.spacing(3),
        paddingTop: theme.spacing(8),
      },
    
      notificationsDiv: {
        display: 'flex',
        width: '50%',
        justifyContent: 'right',
      },
    
      notificationsButton: {
        borderRadius: '10px',
        minWidth:'30px',
        backgroundColor: theme.palette.primary.main,
        right:theme.spacing(2),
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        '& svg': {
          fill: theme.palette.secondary.main,
          width: '30px',
          height: '30px',
        }
      },
    
      leftTitle: {
       width: '50%',
       color: 'gray',
      },
    
      graphContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        marginBottom: theme.spacing(3),
        alignItems: 'center',
        gap: theme.spacing(2),
        position: 'sticky',
        height: '170px',
      },
    
      grayGraph: {
        color: '#dddddd',
        position: 'absolute',
      },
    
      workGraph: {
        color: theme.palette.primary.main,
        position: 'absolute',
      },
    
      pauseGraph: {
        color: theme.palette.yellow.main,
        position:'absolute',
      },
    
      timer: {
        borderRadius: '100%',
        borderColor: '#EBCBD0',
        border: '2px solid',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width:'140px',
        height:'140px'
      },
    
      fimTrabalho: {
        color: '#bbbbbb',
        textAlign: 'center',
      },
    
      typographyTimer: {
        color: '#555555',
        textAlign: 'center',
      },
    
      timersUnderline: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
      },
    
      timerCard: {
        display: 'flex',
        justifyContent: 'center',
        marginRight: theme.spacing(0.7),
        marginLeft: theme.spacing(2),
        '& svg': {
          fill: theme.palette.primary.main,
          width: '30px',
          height: '30px',
        },
      },
    
      timerCard2: {
        display: 'flex',
        justifyContent: 'center',
        marginRight: theme.spacing(0.7),
        marginLeft: theme.spacing(2),
        '& svg': {
          fill: theme.palette.yellow.main,
          width: '30px',
          height: '30px',
        },
      },
    
      fasesTrabalho: {
        color: '#555555',
        marginTop: theme.spacing(3),
      },
    
      stackFasesTrabalho: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: theme.spacing(3),
      },
    
      stackImageIcon: {
        width: '100%',
        height: '60px',
        fill: theme.palette.neutral.main,
      },
    
      selectedItem: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        '& svg':{
          fill: theme.palette.secondary.main,
        }
      },
    
      useInstructions: {
        margin: theme.spacing(3),
        padding: theme.spacing(0),
        borderRadius: '15px',
      },
    
      useInstructionsIcon: {
        fill: theme.palette.secondary.main,
        width: '40px',
        height: '40px',
        backgroundColor: theme.palette.primary.main,
        borderRadius:'10px',
        padding: '0',
      },
    
      useInstructionsHeader: {
        padding: theme.spacing(1),
        fontSize: '10pt'
      }

}));